module.exports = __webpack_public_path__ + "img/bowling-ball-pin.ab147b4c.svg";